import { JSX, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuthContext } from '../contexts/auth.context';
import { UserRole } from '../dto/user';
import { useNavigation } from '../hooks/navigation.hook';
import { PageLoading } from './page-loading';

export function AdminGuard(): JSX.Element {
  const { navigate } = useNavigation();
  const { isUserLoading, user } = useAuthContext();

  const isAdmin = user?.role === UserRole.ADMIN;
  const shouldNavigate = !isUserLoading && !isAdmin;

  useEffect(() => {
    if (shouldNavigate) navigate('/settings', { replace: true });
  }, [isUserLoading, isAdmin]);

  return shouldNavigate ? <PageLoading /> : <Outlet />;
}
